(function () {
  if (window.__FOUNDER_WIDGET_INIT__) return;
  window.__FOUNDER_WIDGET_INIT__ = true;

  // -----------------------------
  // CONFIG: bubble shape/size/position
  // -----------------------------
  const founderWidgetConfig = {
    shape: 'vertical-rect', // 'circle' | 'square' | 'vertical-rect'
    width: 100,
    height: 142,
    bottom: 24,
    right: 24,
    showText: false // hide title/body to reduce layout jumps
  };

  // Letters for choices: A, B, C...
  const FV_CHOICE_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];

  // -----------------------------
  // FLOW CONFIG – 6 NODES
  // -----------------------------
  const founderFlow = {
    startNodeId: 'intro',
    nodes: {
      intro: {
        id: 'intro',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/838bf15349b245938dbd703669c9044e.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'how',
            label: 'How does it work?',
            type: 'node',
            targetId: 'how'
          },
          {
            id: 'why',
            label: 'Why the Livy Method?',
            type: 'node',
            targetId: 'why'
          },
          {
            id: 'gina',
            label: 'Who is Gina Livy?',
            type: 'node',
            targetId: 'gina'
          }
        ]
      },
      how: {
        id: 'how',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/32f9c35e47bb4683b3b78df53e5c15c1.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'why',
            label: 'Why the Livy Method?',
            type: 'node',
            targetId: 'why'
          },
          {
            id: 'what',
            label: 'What am I buying?',
            type: 'node',
            targetId: 'what'
          },
          {
            id: 'gina',
            label: 'Who is Gina Livy?',
            type: 'node',
            targetId: 'gina'
          }
        ]
      },
      why: {
        id: 'why',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/92f348e3309940079ecad315518e27a3.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'what',
            label: 'What am I buying?',
            type: 'node',
            targetId: 'what'
          },
          {
            id: 'who',
            label: 'Who is it for?',
            type: 'node',
            targetId: 'who'
          },
          {
            id: 'get-started',
            label: 'Get Started',
            type: 'link',
            url: '/products/the-livy-method-subscription'
          }
        ]
      },
      what: {
        id: 'what',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/da5b8b1e1b7e402dae24e9143687f818.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'get-started',
            label: 'Get Started',
            type: 'link',
            url: '/products/the-livy-method-subscription'
          },
          {
            id: 'gina',
            label: 'Who is Gina Livy?',
            type: 'node',
            targetId: 'gina'
          },
          {
            id: 'how',
            label: 'How does it work?',
            type: 'node',
            targetId: 'how'
          }
        ]
      },
      who: {
        id: 'who',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/a3e03d48d4894331bac6e53a7ea995c9.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'get-started',
            label: 'Get Started',
            type: 'link',
            url: '/products/the-livy-method-subscription'
          },
          {
            id: 'why',
            label: 'Why the Livy Method?',
            type: 'node',
            targetId: 'why'
          },
          {
            id: 'how',
            label: 'How does it work?',
            type: 'node',
            targetId: 'how'
          }
        ]
      },
      gina: {
        id: 'gina',
        videoSrc:
          'https://cdn.shopify.com/videos/c/o/v/2a444d6b56204391a3fb3f681baf7578.mp4',
        posterSrc: '',
        choices: [
          {
            id: 'what',
            label: 'What am I buying?',
            type: 'node',
            targetId: 'what'
          },
          {
            id: 'who',
            label: 'Who is it for?',
            type: 'node',
            targetId: 'who'
          },
          {
            id: 'how',
            label: 'How does it work?',
            type: 'node',
            targetId: 'how'
          }
        ]
      }
    }
  };

  // -----------------------------
  // STYLES
  // -----------------------------
  function injectStyles() {
    const css = `
      .fv-bubble {
        position: fixed;
        box-shadow: 0 10px 25px rgba(0,0,0,0.25);
        cursor: pointer;
        z-index: 99999;
        background: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      .fv-bubble video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .fv-bubble:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 3px;
      }

      .fv-panel {
        position: fixed;
        z-index: 2147483648;
        background: #111;
        color: #fff;
        border-radius: 8px;
        box-shadow: 0 20px 40px rgba(0,0,0,0.4);
        max-width: 460px;                 /* was 380px */
        width: min(460px, 100vw - 48px);  /* was 380px, 100vw - 24px */
        bottom: 24px;
        right: 24px;
      }

      .fv-panel__inner {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .fv-panel__header {
        display: flex;
        justify-content: flex-end;
        padding: 8px 10px 6px;
      }
      .fv-panel__close {
        background: transparent;
        border: none;
        color: #fff;
        font-size: 15px;
        cursor: pointer;
        line-height: 1;
      }

      .fv-panel__video-wrapper {
        position: relative;
        background: #000;
        width: 100%;
        aspect-ratio: 16 / 9;
      }
      .fv-panel__video {
        width: 100%;
        height: 100%;
        display: block;
        background: #000;
        object-fit: cover;
      }
      .fv-panel__video:focus {
        outline: none;
      }

      .fv-panel__body {
        padding: 10px 16px 14px;
        overflow-y: auto;
      }
      .fv-panel__title {
        font-size: 16px;
        margin: 0 0 4px;
        font-weight: 600;
      }
      .fv-panel__text {
        font-size: 13px;
        line-height: 1.4;
        margin: 0 0 8px;
        opacity: 0.9;
      }

      /* Hide title/text when showText = false */
      .fv-panel[data-show-text="false"] .fv-panel__title,
      .fv-panel[data-show-text="false"] .fv-panel__text {
        display: none;
      }

      .fv-panel__choices {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 8px;
      }

      /* Updated for letter badges + text */
      .fv-panel__choice {
        width: 100%;
        border-radius: 8px;
        border: 1px solid rgba(255,255,255,0.2);
        padding: 9px 14px;
        font-size: 13px;
        background: #1c1c1c;
        color: #fff;
        cursor: pointer;
        text-align: left;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
      }
      @media (hover: hover) and (pointer: fine) {
      .fv-panel__choice:hover {
        background: #fff;
        color: #000;
        border-color: #fff;
      }
      }

      .fv-panel__choice-label {
        width: 22px;
        height: 22px;
        border-radius: 999px;
        border: 1px solid rgba(255,255,255,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 600;
        flex-shrink: 0;
        opacity: 0.9;
      }

      .fv-panel__choice-text {
        flex: 1;
        display: block;
      }

      /* MOBILE LAYOUT: CENTER THE PANEL AND CLAMP WIDTH/HEIGHT */
      @media (max-width: 749px) {
        .fv-panel {
          left: 50%;
          right: auto;
          bottom: 16px;
          transform: translateX(-50%);
          width: calc(100vw - 24px);
          max-height: min(580px, 90vh);
        }
      .fv-panel__choice:active {
          opacity: 0.85;
          transform: scale(0.98);
        }
      }
    `;
    const styleEl = document.createElement('style');
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  // -----------------------------
  // BUBBLE + PANEL
  // -----------------------------
  function createFounderWidget(flow) {
    const rootNode = flow.nodes[flow.startNodeId];
    if (!rootNode) return;

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    // Bubble
    const bubble = document.createElement('div');
    bubble.className = 'fv-bubble';
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('aria-label', 'Open founder video');
    bubble.setAttribute('tabindex', '0');

    // Position + shape
    bubble.style.bottom = (founderWidgetConfig.bottom || 24) + 'px';
    bubble.style.right = (founderWidgetConfig.right || 24) + 'px';

    const width = founderWidgetConfig.width || 88;
    const height = founderWidgetConfig.height || width;
    bubble.style.width = width + 'px';
    bubble.style.height = height + 'px';

    const shape = founderWidgetConfig.shape || 'circle';
    if (shape === 'circle') {
      const size = Math.min(width, height);
      bubble.style.width = bubble.style.height = size + 'px';
      bubble.style.borderRadius = '9999px';
    } else if (shape === 'square') {
      const size = Math.min(width, height);
      bubble.style.width = bubble.style.height = size + 'px';
      bubble.style.borderRadius = '8px';
    } else if (shape === 'vertical-rect') {
      bubble.style.borderRadius = '8px';
    }

    const bubbleVideo = document.createElement('video');
    bubbleVideo.autoplay = true;
    bubbleVideo.loop = true;
    bubbleVideo.muted = true;
    bubbleVideo.playsInline = true;
    bubbleVideo.preload = 'metadata'; // PERF: only load metadata initially
    if (rootNode.posterSrc) bubbleVideo.poster = rootNode.posterSrc;

    const bubbleSource = document.createElement('source');
    bubbleSource.src = rootNode.videoSrc;
    bubbleSource.type = 'video/mp4';
    bubbleVideo.appendChild(bubbleSource);

    bubble.appendChild(bubbleVideo);
    document.body.appendChild(bubble);

    // Panel (created once, reused)
    let panel = null;
    let videoEl = null;
    let titleEl = null;
    let textEl = null;
    let choicesContainer = null;

    function openPanel(nodeId) {
      const node = flow.nodes[nodeId];
      if (!node) return;

      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'fv-panel';
        panel.dataset.showText =
          founderWidgetConfig.showText === false ? 'false' : 'true';

        // Only pin via inline styles on desktop; mobile uses CSS centering
        if (isDesktop) {
          panel.style.bottom = (founderWidgetConfig.bottom || 24) + 'px';
          panel.style.right = (founderWidgetConfig.right || 24) + 'px';
        }

        const inner = document.createElement('div');
        inner.className = 'fv-panel__inner';

        const header = document.createElement('div');
        header.className = 'fv-panel__header';

        const closeBtn = document.createElement('button');
        closeBtn.className = 'fv-panel__close';
        closeBtn.setAttribute('aria-label', 'Close founder video');
        closeBtn.innerHTML = '&#10005;';
        closeBtn.addEventListener('click', () => {
          if (videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
          }
          panel.style.display = 'none';
          bubble.style.display = 'flex';
          bubbleVideo.play().catch(() => {});
        });
        header.appendChild(closeBtn);

        const videoWrapper = document.createElement('div');
        videoWrapper.className = 'fv-panel__video-wrapper';
        videoEl = document.createElement('video');
        videoEl.className = 'fv-panel__video';
        videoEl.setAttribute('controls', 'controls');
        videoEl.playsInline = true;
        videoEl.preload = 'metadata';
        videoWrapper.appendChild(videoEl);

        const body = document.createElement('div');
        body.className = 'fv-panel__body';
        titleEl = document.createElement('h2');
        titleEl.className = 'fv-panel__title';
        textEl = document.createElement('p');
        textEl.className = 'fv-panel__text';
        choicesContainer = document.createElement('div');
        choicesContainer.className = 'fv-panel__choices';

        body.appendChild(titleEl);
        body.appendChild(textEl);
        body.appendChild(choicesContainer);

        inner.appendChild(header);
        inner.appendChild(videoWrapper);
        inner.appendChild(body);
        panel.appendChild(inner);
        document.body.appendChild(panel);
      }

      // Update content for this node
      while (videoEl.firstChild) videoEl.removeChild(videoEl.firstChild);
      const src = document.createElement('source');
      src.src = node.videoSrc;
      src.type = 'video/mp4';
      videoEl.appendChild(src);
      videoEl.load();
      videoEl.play().catch(() => {});
      bubbleVideo.pause();

      titleEl.textContent = node.title || '';
      textEl.textContent = node.body || '';

      choicesContainer.innerHTML = '';
      (node.choices || []).forEach((choice, index) => {
        if (index > 2) return; // soft cap 3 options per node

        const btn = document.createElement('button');
        btn.className = 'fv-panel__choice';

        // Letter badge
        const letterSpan = document.createElement('span');
        letterSpan.className = 'fv-panel__choice-label';
        letterSpan.textContent = FV_CHOICE_LETTERS[index] || '';

        // Text span
        const textSpan = document.createElement('span');
        textSpan.className = 'fv-panel__choice-text';
        textSpan.textContent = choice.label;

        btn.appendChild(letterSpan);
        btn.appendChild(textSpan);

        if (choice.type === 'node') {
          btn.addEventListener('click', () => openPanel(choice.targetId));
        } else if (choice.type === 'link') {
          btn.addEventListener('click', () => {
            window.location.href = choice.url;
          });
        }

        choicesContainer.appendChild(btn);
      });

      panel.style.display = 'block';
      bubble.style.display = 'none';
    }

    function handleOpen() {
      openPanel(flow.startNodeId);
    }

    bubble.addEventListener('click', handleOpen);
    bubble.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleOpen();
      }
    });
  }

  // -----------------------------
  // INIT
  // -----------------------------
  function init() {
    injectStyles();
    createFounderWidget(founderFlow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
